import React, { useState } from 'react';

const AddNewPlayer = ({ players }) => {
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopyClick = () => {
        navigator.clipboard.writeText(window.location.href)
            .then(() => {
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 3000); // Message disappears after 3 seconds
            })
            .catch(err => console.error('Failed to copy URL: ', err));
    };

    const isPrimary = players && players.length === 1; // Check if there's only one player and players is not undefined

    return (
        <div className="sg-stack" style={{ margin: '100px 0', alignItems: 'center', gap: 10 }}>
            <button
                type="button"
                onClick={handleCopyClick}
                className={`sg-btn ${isPrimary ? 'sg-btn--primary' : 'sg-btn--ghost'}`}
            >
                + Add New Player
            </button>
            {copySuccess && (
                <div className="sg-faint sg-anim-fadeup" style={{ textAlign: 'center' }}>
                    Link copied — send it to a friend so they can join 🎉
                </div>
            )}
        </div>
    );
};

export default AddNewPlayer;
